export default "__VITE_ASSET__CV_IYvql__"